import { fmtDate } from "../lib/api";

export function ReportCard({ report, visit, testid = "shift-report-card", compact = false }) {
  const o = report.output || {};
  return (
    <article data-testid={testid} className="rounded-xl border-[1.5px] border-hf-coral/25 bg-hf-coralsoft p-6 sm:p-8">
      <p className="text-[13px] font-semibold uppercase tracking-[0.12em] text-hf-coraldark">
        Shift report from {report.helper_name} {visit?.ended_at ? `· ${fmtDate(visit.ended_at)}` : ""}
      </p>
      <p className={`mt-4 font-heading leading-snug text-hf-ink ${compact ? "text-xl" : "text-2xl sm:text-3xl"}`}>
        {o.story}
      </p>
      <p data-testid={`${testid}-headline`} className="mt-5 inline-flex rounded-full border-[1.5px] border-hf-coral/30 bg-white px-4 py-1.5 font-heading text-lg text-hf-coraldark">
        {o.headline}
      </p>
    </article>
  );
}
